import { createIcon } from "@chakra-ui/icons";

export const HelpCircleIcon = createIcon({
  displayName: "HelpCircleIcon",
  viewBox: "0 0 20 20",
  path: (
    <path
      // d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      d="M7.8175 7.75C7.99383 7.24875 8.34186 6.82608 8.79997 6.55685C9.25807 6.28762 9.79667 6.1892 10.3204 6.27903C10.8441 6.36886 11.3191 6.64114 11.6613 7.04765C12.0035 7.45415 12.1908 7.96864 12.19 8.5C12.19 10 9.94 10.75 9.94 10.75M10 13.75H10.0075M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  defaultProps: {
    width: "20px",
    height: "20px",
  },
});
